import i18n from 'config/i18n';
import { getLocale } from 'utils/date';
import * as yup from 'yup';
import { convertToNullWhenNaN } from 'utils/validation';

const t = i18n.getFixedT(getLocale(), 'common', 'adminPortal.cla');

const nullableNumber = () =>
  yup.number().nullable().transform(convertToNullWhenNaN);

export const hoursPayoutSchema = yup.object({
  payOutOvertimeEnabled: yup.boolean().default(false),
  payOutOvertimeDhtId: nullableNumber().when('payOutOvertimeEnabled', {
    is: true,
    then: (schema) => schema.required(t('errors.required'))
  }),
  payOutOvertimeThreshold: nullableNumber()
    .min(0, t('errors.minZero'))
    .typeError(t('errors.invalidNumber'))
    .when('payOutOvertimeEnabled', {
      is: true,
      then: (schema) => schema.required(t('errors.required'))
    }),
  payOutOvertimeThresholdType: yup
    .string()
    .nullable()
    .default(null)
    .when('payOutOvertimeEnabled', {
      is: true,
      then: (schema) => schema.required(t('errors.required'))
    }),
  payOutOvertimePeriodStart: yup
    .date()
    .nullable()
    .when('payOutOvertimeEnabled', {
      is: true,
      then: (schema) => schema.required(t('errors.required'))
    }),
  payOutOvertimePeriodEnd: yup
    .date()
    .nullable()
    .when('payOutOvertimeEnabled', {
      is: true,
      then: (schema) =>
        schema
          .required(t('errors.required'))
          .min(yup.ref('payOutOvertimePeriodStart'), t('errors.invalidRange'))
    }),
  payOutOvertimeReferenceMonth: yup
    .string()
    .nullable()
    .default(null)
    .when('payOutOvertimeEnabled', {
      is: true,
      then: (schema) => schema.required(t('errors.required'))
    }),
  payOutExtraLegalEnabled: yup.boolean().default(false),
  payOutExtraLegalDhtId: nullableNumber().when('payOutExtraLegalEnabled', {
    is: true,
    then: (schema) => schema.required(t('errors.required'))
  }),
  payOutExtraLegalThreshold: nullableNumber()
    .min(0, t('errors.minZero'))
    .typeError(t('errors.invalidNumber'))
    .when('payOutExtraLegalEnabled', {
      is: true,
      then: (schema) => schema.required(t('errors.required'))
    }),
  payOutExtraLegalThresholdType: yup
    .string()
    .nullable()
    .default(null)
    .when('payOutExtraLegalEnabled', {
      is: true,
      then: (schema) => schema.required(t('errors.required'))
    }),
  payOutExtraLegalPeriodStart: yup
    .date()
    .nullable()
    .when('payOutExtraLegalEnabled', {
      is: true,
      then: (schema) => schema.required(t('errors.required'))
    }),
  payOutExtraLegalPeriodEnd: yup
    .date()
    .nullable()
    .when('payOutExtraLegalEnabled', {
      is: true,
      then: (schema) =>
        schema
          .required(t('errors.required'))
          .min(yup.ref('payOutExtraLegalPeriodStart'), t('errors.invalidRange'))
    })
});
